import React from "react";

export const Footer: React.FC = () => {
    return (
        <footer className="footer">
            <p className="footer__content">This site is funded by the Florida Department of Education, Bureau of Exceptional Education and Student Services, through federal funds under the Individuals with Disabilities Education Act (IDEA), Part B.</p>
        </footer>
    );
};
